<template>
    <div class="progress">
        <span class="progress__current" :class="{'progress__current__complete' : showCompleteMessage}" :style="{'left': `${progress - 2}%`}">{{current | minutes}}</span>

        <div class="progress-bar"
             role="progressbar"
             :class="{'complete': showCompleteMessage}"
             :style="{'width': `${progress}%`}"
             :aria-valuenow="progress"
             aria-valuemin="0"
             aria-valuemax="100">

            <span v-if="showCompleteMessage" class="progress-bar__message text-center">
                {{'dro.behaviour_absent' | trans}}
            </span>
        </div>

        <span class="progress__times">{{'dro.list.time' | trans}} {{max | minutes}}</span>
        <span class="progress__times__modal" v-if="!showCompleteMessage">{{current | minutes}}</span>
    </div>
</template>

<script>
  import {mapState} from 'vuex';

  export default {
    computed: {
      ...mapState('dro/session', [
        'currentInterval',
      ]),
      current() {
        return this.currentInterval.current;
      },
      max() {
        return this.currentInterval.duration;
      },
      showCompleteMessage() {
        return this.current >= this.max;
      },
      progress() {
        return ((this.current / this.max) * 100).toFixed(2);
      },
    },
  };
</script>


// WEBPACK FOOTER //
// src/modules/dro/components/IntervalProgressBar.vue